import * as landingPageActions from '../actions/landingPageAction';
import BASEURL from '../../config';
import cookieLib from '../helpers/cookieLib';

const landingPage = (state = {}, action) => {
  switch (action.type) {
    case landingPageActions.USER_INFO: {
      return {
        ...state,
        isUserInfoCalling: true,
      };
    }
    case landingPageActions.UPDATE_VALUE: {
      const userInfo = action.payload.user_info;
      const isAnalytics = userInfo.permission_list?.includes(
        'get_chartanalytics',
      );
      const analyticsProduct = {
        redirect_type: 'ANALYTICS',
        display_name: 'Analytics',
        is_default: false,
        product_type: { 0: 'Happay Defined' },
        redirection_url: `https://admin.${
          BASEURL === 'https://api-v2.happay.in/' ? '' : 'uat.'
        }happay.in/analytics`,
        id: 9999999,
      };

      let prdList = state.productList || [];

      if (isAnalytics) {
        prdList = [...prdList, analyticsProduct];
      }

      return {
        ...state,
        userInfo,
        productList: prdList,
        isUserInfoCalling: false,
      };
    }
    case 'CLEARALL': {
      return {};
    }
    case 'UPDATE_WALLET_LIMIT': {
      return {
        ...state,
        wallet_limit: action.data,
      };
    }
    case 'SET_INVOICE_PRODUCT': {
      return {
        ...state,
        productList: [...action.data, ...(state.productList || [])],
        productListAPICall: true
      };
    }
    case 'SET_DASHBOARD_VIEW': {
      return {
        ...state,
        ...action.data,
      };
    }
    case 'SET_ONBOARD_SET': {
      return {
        ...state,
        ONBOARD: action.data,
      };
    }
    case 'SET_ACTIVATE_CARD_ONBOARD': {
      return {
        ...state,
        activatestatus: action.data,
      };
    }
    case 'SET_TUTORIAL_FLAG': {
      cookieLib.setCookieByKey(
        'show_ipp_tutorial_flag',
        action.data.show_ipp_tutorial_flag,
      );
      return {
        ...state,
        tutorialFlagResponse: action.data,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default landingPage;
